import { render, staticRenderFns } from "./Importar_Bitacora.vue?vue&type=template&id=21fdfc2d&"
import script from "./Importar_Bitacora.vue?vue&type=script&lang=js&"
export * from "./Importar_Bitacora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports